<template>
    <div v-if="config.display" :style="{'width': config.width || '100%'}" class="control e-control">
        <label-wrapper :label-settings="config"></label-wrapper>
        <calc-editor :cId="calcEditorId" :cType="calcEditorType" :prop-field-options="options" :prop-value="value"  @update:prop-value="value = $event"></calc-editor>
        <p v-if="config.message" class="input-info" v-html="ddStoreFilter(config.message)"></p>
    </div>
</template>

<script>
import { controlMixins } from "./controlMixins.js";

const editorSettings = {};

export const calcControlComponent = {
    editorSettings: editorSettings,
    mixins: [controlMixins],
    computed: {
        showClearButton() {
            return typeof this.realConfig.showClearButton !== 'undefined' ? this.realConfig.showClearButton : true;
        },
        calcEditorId() {
            return 'calcEditor__' + this.config.name;
        },
        calcEditorType() {
            return 'calcEditor';
        }
    }
};

export default calcControlComponent;
</script>
